import {Assigned} from './assinged'
import {DateRange} from './date-range'
import {Length} from './length'
import {Menu} from './menu'
import {Title} from './title'
import {column} from './utils'

export const renderTitle = column(Title)

export const renderAssigned = column(Assigned)

export const renderDateRange = column(DateRange)

export const renderLength = column(Length)

export const renderMenu = column(Menu)
